import { combineReducers } from 'redux';

import { reducer as updateUserInfoReducer } from './updateUserInfo';
import { reducer as updateMembershipReducer } from './updateMembership';
import { reducer as updatePointsReducer } from './updatePoints';
import { reducer as fetchUsersDataReducer } from './fetchUsersData';
import { reducer as getUserDetailsReducer } from './getUserDetails';
import { reducer as fetchNewUsersReducer } from './fetchNewUsers';

export default combineReducers({
  updateUserInfo: updateUserInfoReducer,
  updateMembership: updateMembershipReducer,
  updatePoints: updatePointsReducer,
  fetchUsersData: fetchUsersDataReducer,
  getUserDetails: getUserDetailsReducer,
  fetchNewUsers: fetchNewUsersReducer,
});
